// This function will run a throttled script every 150 ms
var didScroll;
var scrollTimer = null;
window.addEventListener('scroll', function(event) {
  didScroll = true;
});

setInterval(function() {
  if (didScroll) {
    fixHeader();
    didScroll = false;
  }
}, 150);

function fixHeader() {

  // Detect scroll position
  var scrollPosition = Math.round(window.scrollY);

  // If we've scrolled 100px, add "sticky" class to the header
  if (scrollPosition > 100) {
    document.querySelector('.site-header').classList.add('is-stuck');
  }
  // If not, remove "sticky" class from header
  else {
    document.querySelector('.site-header').classList.remove('is-stuck');
  }
}

//window.addEventListener('scroll', fixHeader);